import { computed, ref } from 'vue'

export default (props: any, emits: any, getDataDebounce: any, cValue: any, hide: any) => {
  const { text, keyId, keyLabel, keyDisabled, multiple, disabled, readonly, clearable, confirmChange, labelOnlyShowText } = toRefs(props)
  const cItems = ref<any[]>([])
  const changing = ref<boolean>(false)
  const confirmed = ref(false)
  const fnConfirm = ref<Function>()

  const cLabelTemp = ref<string>('')
  const cLabel = computed({
    get () {
      if (labelOnlyShowText?.value) {
        return text.value
      }
      return cLabelTemp.value
    },
    set (val: any) {
      cLabelTemp.value = val
      emits('update:text', cLabel.value)
    }
  })

  const selectedItems = ref<any>([])
  const selectedItemKeys = computed(() =>
    selectedItems.value.map((item: any) => {
      return item[keyId.value]
    })
  )

  const selectedItemLength = computed<number>(() => selectedItems.value.length)
  const itemsSelectAllLength = computed<number>(() => cItems.value.filter((c: any) => !c.disabled).length)
  const isSelectedAll = computed(() => {
    if (selectedItemLength.value <= 0) {
      return false
    }
    let result = true
    cItems.value.forEach((item: any) => {
      const exists = selectedItems.value.find((i: any) => i[keyId.value] === item[keyId.value])
      if (!exists) {
        result = false
      }
    })
    return result
  })
  const selectAllAvailable = computed<boolean>(
    () => !isSelectedAll.value && itemsSelectAllLength.value > 0 && multiple.value && !disabled.value && !readonly.value
  )

  const isDisabled = (item: any) => {
    return !selectedItemKeys.value.includes(item[keyId.value]) && item[keyDisabled.value]
  }
  const clearConfirm = () => {
    confirmed.value = false
    fnConfirm.value = () => {}
  }
  const handleSelect = (item: any) => {
    if (isDisabled(item)) {
      return
    }
    changing.value = true
    const val = item[keyId.value]
    const exists = selectedItems.value.findIndex((i: any) => i[keyId.value] === val)
    if (multiple.value) {
      if (exists >= 0) {
        if (confirmChange.value) {
          if (!confirmed.value) {
            hide()
            confirmed.value = true
            fnConfirm.value = () => handleSelect(item)
            return
          }
        }
        selectedItems.value.splice(exists, 1)
      } else {
        selectedItems.value.push(item)
      }
      cValue.value = [...selectedItemKeys.value]
    } else {
      if (exists >= 0) {
        if (!clearable.value) {
          return
        }
        if (confirmChange.value) {
          if (!confirmed.value) {
            hide()
            confirmed.value = true
            fnConfirm.value = () => handleSelect(item)
            return
          }
        }
        selectedItems.value = []
        cValue.value = ''
        cLabel.value = ''
      } else {
        if (selectedItems.value && selectedItems.value.length && confirmChange.value) {
          if (!confirmed.value) {
            hide()
            confirmed.value = true
            fnConfirm.value = () => handleSelect(item)
            return
          }
        }
        selectedItems.value = [item]
        cValue.value = val
        cLabel.value = item[keyLabel.value]
      }

      nextTick(() => {
        hide()
        getDataDebounce('')
      })
    }
    nextTick(() => {
      changing.value = false
      clearConfirm()
    })
  }
  const handleSelectAll = () => {
    if (!selectAllAvailable.value) {
      return
    }

    cItems.value.forEach((item: any) => {
      if (item.disabled) {
        return
      }
      const exists = selectedItems.value.findIndex((i: any) => i[keyId.value] === item[keyId.value])
      if (exists < 0) {
        selectedItems.value.push(item)
      }
    })
    cValue.value = [...selectedItemKeys.value]
  }
  return {
    cItems,
    changing,
    cLabelTemp,
    cLabel,
    confirmed,
    fnConfirm,
    selectedItems,
    selectedItemKeys,
    selectedItemLength,
    itemsSelectAllLength,
    isSelectedAll,
    selectAllAvailable,
    isDisabled,
    clearConfirm,
    handleSelect,
    handleSelectAll
  }
}
